import { render } from "./TikTokPostReview.vue?vue&type=template&id=4d18b0d6&scoped=true"
import script from "./TikTokPostReview.vue?vue&type=script&lang=js"
export * from "./TikTokPostReview.vue?vue&type=script&lang=js"

import "./TikTokPostReview.vue?vue&type=style&index=0&id=4d18b0d6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d18b0d6"]])

export default __exports__